module.exports = __webpack_public_path__ + "static/colophon-logo-8ac22bf8947f16dbf729f418f2ab2f84.svg";